'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionExpiredDialog = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SessionExpiredDialog = require('./SessionExpiredDialog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!_react2.default) {
    throw new Error('"rio-session-expired-info" needs a global React on the page');
}

if (!_reactDom2.default) {
    throw new Error('"rio-session-expired-info" needs a global ReactDOM on the page');
}

exports.SessionExpiredDialog = _SessionExpiredDialog.SessionExpiredDialog;